// PageLayout.js - Reusable layout wrapper for page content.
// This functional component provides a consistent body layout (centered, responsive container) for all pages,
// mimicking the structure used in the home route. It takes children as props to wrap any page-specific content,
// ensuring uniform styling across routes (e.g., invoice form, history, terms, privacy policy).
// Uses Bootstrap classes for responsiveness and centering.
import React from 'react';
import Container from 'react-bootstrap/Container';

const PageLayout = ({ children }) => {
  return (
    <div className="App d-flex flex-column align-items-center justify-content-center w-100 mt-4">
      <Container>
        {children}
      </Container>
    </div>
  );
};

export default PageLayout;